import { Fragment, useState } from 'react';
import { EventConfirmIcon, CaretRightIcon, DocumentIcon, GearIcon, PlusIcon } from 'assets/icons';
import { BookmarkSquareIcon } from '@heroicons/react/24/outline';
import { useQuery } from '@apollo/client';
import { formatApiDate } from 'utils/formatter';
import Flyout, { useFlyout } from 'components/Flyout/Flyout';
import Edit from './Edit';
import { default as NewEntry } from './Entries/New';
import New from './New';
import { Link } from 'react-router-dom';
import { useSession } from 'contexts/SessionContext';
import { GetLogbooksDocument } from 'graphql/generated';
import { BookOpenIcon, EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import Button from 'components/Button/Button';
import Paywall from 'components/Paywall/Paywall';
import { Menu, Transition } from '@headlessui/react';
import isMobileApp from 'utils/isMobileApp';
import Header from 'components/Header/Header';
import ThumbButton from 'components/ThumbButton/ThumbButton';

const Logbooks = function () {
  const { craftId, organizationSubtype } = useSession();
  const { data } = useQuery(GetLogbooksDocument, { variables: { craftId } });
  const { flyoutProps, updateFlyout, closeFlyout } = useFlyout();
  const listLogbooks = data?.logBooks;

  return (
    <>
      <Flyout {...flyoutProps} />
      {/* Header */}
      <Header title="Logbooks" icon={BookOpenIcon}>
      { organizationSubtype !== 'FREE' && 
        <>
          <div className="flex items-stretch gap-2">
            <Button className="hidden md:flex" text="Add Logbook" color="navy" size="xs" icon={<BookmarkSquareIcon className="h-3 w-3 mr-1 stroke-[0.15rem]" />} onClick={ () => updateFlyout({ title: 'Add Logbook', content: <New closeFlyout={closeFlyout}/> }) } />
          </div>
          <ThumbButton onClick={ () => updateFlyout({ title: 'Add Logbook', content: <New closeFlyout={closeFlyout}/> }) } size="primary" role="add"/>
        </>
      }
      </Header>
      <div>
        {organizationSubtype === 'FREE' ? <Paywall /> :
          <div className="flex flex-wrap gap-2 w-full">
              {listLogbooks?.length ?
                listLogbooks.map((book, index) => {
                  return (
                    <div key={book.id} className={`w-full md:w-[calc(50%-0.25rem)]`}>
                      <div className="flex flex-col bg-white rounded border border-slate-300">
                        <Link to={`/aircraft/logbooks/${book.id}`} className="flex items-center justify-between p-4">
                          <div className="flex items-center">
                            <EventConfirmIcon className="h-12 w-12 p-3 mr-3 text-brand-electric bg-brand-pale rounded border border-brand-electric" />
                            <div className="flex flex-col">
                              <span className="font-bold text-brand-dark">{book.name ?? ''}</span>
                              <span className="text-xs -mt-1">Last Entry: {formatApiDate(book.lastEntry?.logDate) || 'N/A'}</span>
                            </div>
                          </div>
                          <CaretRightIcon className="h-4 w-4 ml-1" />
                        </Link>
                        <div className="border-t px-4 py-2 flex flex-row-reverse items-center justify-start text-sm bg-slate-50 rounded-b">
                          <button
                            className="flex items-center justify-center font-bold bg-white hover:text-white hover:bg-brand-electric transition text-brand-electric border-brand-electric border py-1 px-2 rounded grow"
                            onClick={() => {
                              updateFlyout({ title: `New Entry - ${book.name}`, content: <NewEntry closeFlyout={closeFlyout} id={book?.id} /> });
                            }}>
                            <DocumentIcon className="h-3 w-3 mr-1" /> New Entry
                          </button>
                          <button
                            className="flex items-center justify-center font-bold bg-white hover:text-white hover:bg-brand-electric transition text-brand-electric border-brand-electric border py-1 px-2 rounded mx-1 grow"
                            onClick={() => {
                              updateFlyout({ title: book.name, content: <Edit closeFlyout={closeFlyout} id={book.id} /> });
                            }}>
                            <GearIcon className="h-3 w-3 mr-1" /> Edit
                          </button>
                          <span className="font-semibold text-center border py-1 px-2 rounded grow bg-white">{book.totalEntries} Total Entries</span>
                        </div>
                      </div>
                    </div>
                  );
                }) : <div className="w-full text-center justify-center flex flex-col gap-5 pt-10">
                  <span className='text-2xl font-bold'>No logbooks found</span>  
                  <Button text="+ Add First Logbook" color="navy" size="sm"
                    onClick={ () => updateFlyout({ title: 'Add Logbook', content: <New closeFlyout={closeFlyout}/> }) } />
                </div>}
          </div>
        }
      </div>
    </>
  );
};

export default Logbooks;
